"use strict";

exports.__esModule = true;
exports.default = void 0;
const ALLOWED_PROPS = ["size", "color", "customColor", "className", "dataTest", "ariaHidden", "reverseOnRtl", "ariaLabel", "dataTest"];
const whiteListProps = props => Object.assign({}, ...ALLOWED_PROPS.map(k => k in props ? {
  [k]: props[k]
} : {}));
var _default = whiteListProps;
exports.default = _default;